import React from "react"
import { graphql } from "gatsby"

import Reveal from "components/utils/Reveal"

import SectionStyling from "components/atoms/SectionStyling"
import StandardPadding from "components/atoms/StandardPadding"
import GenericGrid from "components/molecules/GenericGrid"
import Box from "components/atoms/Box"

import SectionText from "components/molecules/SectionText"

const AdvisorsGrid = ({
  sectionStyling,
  sectionText,
  flexGrid,
  advisors,
  button,
  idx,
}) => {
  const backgroundColor = sectionStyling.backgroundColor
  return (
    <SectionStyling first={idx === 0} {...sectionStyling}>
      <StandardPadding>
        {sectionText && (
          <Reveal>
            <SectionText {...sectionText} mb={8} maxWidth={42} />
          </Reveal>
        )}
        <GenericGrid
          cardType="team"
          flexGrid={flexGrid}
          items={advisors}
          button={button}
          textColor={backgroundColor === "white" ? "darkBlue" : "gold"}
        />
      </StandardPadding>
    </SectionStyling>
  )
}

export default AdvisorsGrid

export const query = graphql`
  fragment AdvisorsGrid on ContentfulAdvisorsGrid {
    sectionStyling {
      ...SectionStyling
    }
    sectionText {
      ...SectionText
    }
    flexGrid {
      ...FlexGrid
    }
    advisors {
      ...TeamCard
    }
    button {
      ...Button
    }
  }
`
